import { render, staticRenderFns } from "./Devolucion.vue?vue&type=template&id=763e5be8&scoped=true&"
import script from "./Devolucion.vue?vue&type=script&lang=js&"
export * from "./Devolucion.vue?vue&type=script&lang=js&"
import style0 from "./Devolucion.vue?vue&type=style&index=0&id=763e5be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763e5be8",
  null
  
)

export default component.exports